import * as types from "./types";

const mutations = {
    [types.GET_FEEDBACK_ID](state, feedbackId) {
        state.feedbackId = feedbackId;
    },
};

export default mutations;